import React, { createContext, useContext } from 'react'
import { OrdersetSettingsPageLogicContract } from './OrdersetSettingsPageLogicContract'

const OrdersetSettingsPageLogicContext = createContext<OrdersetSettingsPageLogicContract | null>(null)

export const useOrdersetSettingsPageBusinessLogic = (): OrdersetSettingsPageLogicContract | null => {
  return useContext(OrdersetSettingsPageLogicContext)
}

interface ComponentProps extends React.ComponentProps<any>, OrdersetSettingsPageLogicContract {}

export const OrdersetSettingsPageBusinessLogicProvider: React.FunctionComponent<ComponentProps> = (
  props: React.PropsWithChildren<ComponentProps>,
) => {
  const { children, ...rest } = props

  return <OrdersetSettingsPageLogicContext.Provider value={rest}>{children}</OrdersetSettingsPageLogicContext.Provider>
}
